import { Box, Divider, List, Paper } from '@mui/material';
import { FieldValues, FormProvider, SubmitHandler, useFormContext } from 'react-hook-form';
import {
  LuBookOpenCheck,
  LuClock,
  LuFileClock,
  LuGraduationCap,
  LuMap,
  LuPlane,
  LuSearch,
} from 'react-icons/lu';
import { TechFetchSearch } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import CheckboxListFilter from '../../../../components/filters/components/CheckboxListFilter';
import AdvancedFiltersHeader from '../../../../utils/AdvancedFiltersHeader';
import BasicSearchForm from '../../types/IBasicSearchForm';
import {
  degreeCheckBoxOptions,
  domainExposureCheckBoxOptions,
  experiencesCheckBoxOptions,
  prefferedEmployedCheckBoxOptions,
  searchPatternOptions,
  usExperienceCheckBoxOptions,
  willingRelocateOptions,
  workAuthorizationCheckBoxOptions,
} from '../utils/TechFetchHelper';

import SelectFilters from './SelectFilter';

interface AdvanceFilterNewProps {
  performSearch: (values: BasicSearchForm & TechFetchSearch) => void;
}

const AdvanceFilterNew = ({ performSearch }: AdvanceFilterNewProps) => {
  const methods = useFormContext();
  const { handleSubmit, reset } = methods;

  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch as SubmitHandler<FieldValues>)}
          onReset={() => reset()}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <SelectFilters
              name="allAny"
              title="Search Pattern"
              selectArray={searchPatternOptions}
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            />
            <SelectFilters
              name="willingToRelocate"
              title="Willing to Relocate"
              selectArray={willingRelocateOptions}
              startIcon={<LuMap color={WsColors.TertiaryShades800} />}
            />
            <CheckboxListFilter
              name="workAuthorizations"
              options={workAuthorizationCheckBoxOptions}
              title="Work Authorization"
              startIcon={<LuPlane color={WsColors.TertiaryShades800} />}
            />

            <CheckboxListFilter
              name="experiences"
              options={experiencesCheckBoxOptions}
              title="Experience"
              startIcon={<LuClock color={WsColors.TertiaryShades800} />}
            />

            <CheckboxListFilter
              name="degrees"
              options={degreeCheckBoxOptions}
              title="Degree"
              startIcon={<LuGraduationCap color={WsColors.TertiaryShades800} />}
            />

            <CheckboxListFilter
              name="preferredEmploymentTypes"
              options={prefferedEmployedCheckBoxOptions}
              title="Preferred Employment Type"
              startIcon={<LuFileClock color={WsColors.TertiaryShades800} />}
            />

            <CheckboxListFilter
              name="usExperiences"
              options={usExperienceCheckBoxOptions}
              title="US Experience"
              startIcon={<LuClock color={WsColors.TertiaryShades800} />}
            />
            <CheckboxListFilter
              name="domainExposures"
              options={domainExposureCheckBoxOptions}
              title="Domain Exposure "
              startIcon={<LuBookOpenCheck color={WsColors.TertiaryShades800} />}
            />
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};

export default AdvanceFilterNew;
